import React from 'react';
import classnames from 'classnames';
import bemBlock from '@gik/core/utils/bemBlock';
import PageSection, { IPageSectionProps } from '../PageSection';
import { UIGradient, UISectionDecoration } from '@gik/ui//types';

export interface IPageHeaderProps extends IPageSectionProps {
  variant?: UIGradient;
  contained?: boolean;
  decoration?: UISectionDecoration;
}

export default function PageHeader({
  children,
  decoration,
  className,
  ...otherProps
}: IPageHeaderProps): React.ReactElement {
  const bem = bemBlock('page-header');
  const blockClasses = classnames([bem(), className || '']);

  return (
    <PageSection asElement={'header'} decoration={decoration} className={blockClasses} {...otherProps}>
      {children}
    </PageSection>
  );
}
